import React from 'react';
import { InputCheckbox } from '@components/input-checkbox';
import { InputRadio } from '@components/input-radio';
import classNames from 'classnames';

import { CHECKBOX, InputCardProps, RADIO, VARIANT_L } from './input-card.type';

export const InputCard = ({ type, variant, isChecked, isDisabled, children, handleClick }: InputCardProps) => {
  const inputs = {
    [RADIO]: <InputRadio checked={isChecked} tabIndex={-1} readOnly />,
    [CHECKBOX]: (
      <div
        className={classNames('flex align-middle', {
          'mr-3': variant !== VARIANT_L,
          'mr-4': variant === VARIANT_L,
        })}>
        <InputCheckbox value={isChecked} checked={isChecked} tabIndex={-1} readOnly />
      </div>
    ),
  };

  return (
    <button className='w-full' type='button' disabled={isDisabled} onClick={handleClick}>
      <div
        className={classNames('flex item-center w-full rounded-md bg-surface-primary', {
          'py-3 px-4 shadow-md': variant !== VARIANT_L,
          'p-6 border border-extra-soft hover:border-hard focus:border-hard items-start': variant === VARIANT_L,
          'opacity-50': isDisabled,
          'opacity-100': !isDisabled,
        })}>
        {inputs[type]}
        {children}
      </div>
    </button>
  );
};
